export const Work = [
    {
        id:1,
        name:"Movie App",
        description:"It is build on top of the React JS, with MaterializeCss and omdbapi for movie information.",
        tags:["react","materialize-css", "omdbapi",],
        
        demo:"https://movie-app-alibekoff.netlify.app/",
        github:"https://github.com/alibekov-zafarbek/Movie-app"
    },
    {
        id:2,
        name:"Twitter Analog Clone",
        description:"This is a great little twitter analog.",
        tags:["react","bootstrap"],
        
        demo:"https://twitter-analog-alibekoff.netlify.app",
        github:"https://github.com/alibekov-zafarbek/Twitter-Analog"
        
    },
    {
        id:3,
        name:"Shop App",
        description:"this project focused mainly on functionality in ReactJS and was developed with the Fortnite api.",
        tags:["react","fortnite-api","materialize-css"],
        
        demo:"https://shop-app-alibekoff.netlify.app/",
        github:"https://github.com/alibekov-zafarbek/Shop-Project"
    },
    {
        id:4,
        name:"Foods App",
        description:"this project focuses mainly on functionality in ReactJS processed with react-router-dom and data from themealdb.",
        tags:["react","materialize-css","react-router", "mealdb-api"],
        
        demo:"https://foods-app-alibekoff.netlify.app",
        github:"https://github.com/alibekov-zafarbek/Foods-react-router-dom"
       
    },{
        id:5,
        name:"Calculator",
        description:"The calculator is made using styled-components.",
        tags:["react","styled-components"],
        
        demo:"https://calculator-app-alibekoff.netlify.app",
        github:"https://github.com/alibekov-zafarbek/Calculator-App"
        
    },
    {
        id:6,
        name:"My First Portfolio",
        description:"A simple first portfolio.",
        tags:["html","css", "javascript"],
        
        demo:"https://zafarbekportfolio.netlify.app",
        github:"https://github.com/alibekov-zafarbek/"
        
    },
    {
        id:7,
        name:"Arzon Ulgurja laboratoriya",
        description:"Web site for the sale of laboratory equipment.",
        tags:["html","css", "javascript"],
        
        demo:"https://arzonulgurjilaboratoriya.uz/",
        github:"https://github.com/alibekov-zafarbek/"
        
    },
    {
        id:8,
        name:"Root CRM",
        description:"structured web site for training centers",
        tags:["react","redux", "redux-thunk", "bootstrap"],
        
        demo:"http://root.rootcrm.ru/",
        github:"https://github.com/alibekov-zafarbek/"
        
    },
    
  
] 